module.exports = __webpack_public_path__ + "img/IMG_2331.bbb03ecd.jpg";